import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { fieldAPI } from '../lib/api';
import { Loader2 } from 'lucide-react';

export default function FieldProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [fieldBoy, setFieldBoy] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // If field boy data was passed from login, use it directly
    if (location.state?.fieldBoy) {
      setFieldBoy(location.state.fieldBoy);
      setIsAuthenticated(true);
      return;
    }

    const checkAuth = async () => {
      try {
        const response = await fieldAPI.getMe();
        setFieldBoy(response.data);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Field auth check failed:', error);
        setIsAuthenticated(false);
        navigate('/field/login', { replace: true });
      }
    };

    checkAuth();
  }, [navigate, location.state]);

  // Loading state
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <Loader2 className="h-10 w-10 animate-spin text-brand-primary mx-auto mb-4" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Not authenticated
  if (!isAuthenticated) {
    return null;
  }

  // Pass fieldBoy to children
  return typeof children === 'function' ? children({ fieldBoy }) : children;
}
